// Respuestas guionadas del Asistente 24/7 (sin IA real).
// Hacen match por palabras clave sobre la ficha de la propiedad seleccionada.

export function respuestaAsistente(texto, prop) {
  const t = (texto || "").toLowerCase();
  const precio = "$ " + prop.precio.toLocaleString("es-AR");
  const exp = "$ " + prop.expensas.toLocaleString("es-AR");

  const reglas = [
    {
      claves: ["precio", "cuánto", "cuanto", "sale", "vale", "alquiler"],
      resp: `El alquiler de ${prop.direccion} es de ${precio} por mes más ${exp} de expensas.`,
    },
    {
      claves: ["expensa"],
      resp: `Las expensas son de ${exp} por mes e incluyen servicios comunes del edificio.`,
    },
    {
      claves: ["m2", "metros", "superficie", "tamaño", "ambientes", "ambiente"],
      resp: `Son ${prop.m2} m² totales (${prop.m2Cubiertos} m² cubiertos), ${prop.ambientes} ambientes, ${prop.dormitorios} dormitorio(s) y ${prop.banos} baño(s).`,
    },
    {
      claves: ["mascota", "perro", "gato"],
      resp: prop.mascotas
        ? "Sí, en esta propiedad se admiten mascotas 🐾."
        : "En esta propiedad el reglamento no permite mascotas.",
    },
    {
      claves: ["requisito", "garantía", "garantia", "caución", "caucion", "papeles"],
      resp: `Pedimos ${prop.requisitos}`,
    },
    {
      claves: ["disponible", "disponibilidad", "libre", "mudar", "entrar", "cuando"],
      resp: prop.disponible
        ? "La unidad está disponible para mudarse a partir de este mes."
        : "La unidad está actualmente ocupada; coordinamos la visita con el inquilino.",
    },
    {
      claves: ["cochera", "garage", "estacionamiento"],
      resp: prop.cochera ? "Sí, la unidad cuenta con cochera." : "Esta unidad no incluye cochera.",
    },
    {
      claves: ["amenities", "pileta", "sum", "gimnasio", "parrilla"],
      resp: prop.amenities.length
        ? `El edificio cuenta con: ${prop.amenities.join(", ")}.`
        : "El edificio no cuenta con amenities adicionales.",
    },
    {
      claves: ["visita", "ver", "conocer", "agendar", "turno", "recorrer"],
      resp:
        "¡Buenísimo! Puedo coordinarte una visita. Tengo disponibilidad mañana a las 18:00 o el sábado a las 11:00. ¿Cuál te viene mejor? 📅",
      ofreceVisita: true,
    },
    {
      claves: ["hola", "buenas", "buen día", "buenos"],
      resp: `¡Hola! Soy el asistente de la inmobiliaria. Estás consultando por ${prop.titulo} (${prop.direccion}). ¿Qué querés saber: precio, expensas, requisitos, mascotas o coordinar una visita?`,
    },
  ];

  for (const r of reglas) {
    if (r.claves.some((c) => t.includes(c))) {
      return { texto: r.resp, ofreceVisita: !!r.ofreceVisita };
    }
  }

  return {
    texto: `Gracias por tu mensaje. Sobre ${prop.titulo} puedo contarte el precio (${precio}), las expensas, los m², los requisitos, si admite mascotas y coordinar una visita. ¿Qué necesitás? Son las 21:30 y la oficina está cerrada, pero te sigo respondiendo igual. 🌙`,
    ofreceVisita: false,
  };
}
